import { IBooking, ICustomer } from "shared-types/SharedTypes";

export interface IEditBookingNotes extends IProps, IServices {}

export interface IBaseProps {
}

export interface IContainerProps extends IBaseProps {
  booking: IBooking;
  handleClose: () => void;
  broadcast: (booking: IBooking) => void;
  showDialog: boolean;
}
export interface IProps extends IBaseProps {

  showDialog: boolean;
  saving: boolean;
  saveError: boolean;
  errorMsg: string;
  loadCustomerError: boolean;
  customerErrorMsg: string;

  booking: IBooking,
  customer?: ICustomer,

  staffEditEnabled: boolean;
  isManager: boolean;

  staffError: boolean;
}

export interface IHandlers {
  handleSave: (bookingNotes: string, customerNotes: string, managerNotes: string, staffName: string) => void;
  handleClose: () => void;
}

export interface IServices {
}

export interface IDialogComponentProps {
  id?: string;
  children?: React.ReactNode;
  onClose?: () => void;
  className?: any;
}

export interface ILinkTextAreaReactProps {
  style?: Object;
  labelText: string;
  value: string;
  handleChange: (value: string) => void;
  enableTextLink?: boolean,
  validation?: boolean,
  error?: boolean,
  errorMsg?: string,
  dataTestId?: string,
}

export enum IEditNoteType {
  Booking = 'Booking',
  Customer = 'Customer',
  Manager = 'Manager',
  Staff = 'Staff',
}

export const classPrefix = 'EditBookingNotes';
